import { atom } from "jotai";

export type ScmpPwaArticleSpeechAppConfig = {
  forceHideByArticleEntityId?: string[];
  forceHideByFlag?: string[];
  forceHideBySectionEntityId?: string[];
  forceHideByTopicEntityId?: string[];
  forceHideByTypeEntityId?: string[];
};

/**
 * Hydrated from the article page query during SSR so the widget force-hide decision
 * is identical on the server and on the client.
 */
export const scmpArticleSpeechConfigAtom = atom<ScmpPwaArticleSpeechAppConfig | undefined>(
  undefined,
);
